// src/store/modules/user.js
const state = {
  // 用户信息
  userInfo: null,
  // 用户token
  token: localStorage.getItem('token') || '',
  // 企业微信用户信息
  wxUserInfo: null,
  // 权限列表
  permissions: [],
  // 部门信息
  department: null
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  SET_WX_USER_INFO(state, wxUserInfo) {
    state.wxUserInfo = wxUserInfo
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  },
  SET_DEPARTMENT(state, department) {
    state.department = department
  },
  CLEAR_USER(state) {
    state.userInfo = null
    state.token = ''
    state.wxUserInfo = null
    state.permissions = []
    state.department = null
    localStorage.removeItem('token')
    sessionStorage.removeItem('token')
  }
}

const actions = {
  // 用户登录
  async login({ commit, dispatch }, { username, password, wxCode }) {
    try {
      let response
      
      if (wxCode) {
        // 企业微信扫码登录
        response = await this._vm.$api.user.wxLogin(wxCode)
      } else {
        // 账号密码登录
        response = await this._vm.$api.user.login({ username, password })
      }
      
      const { token, userInfo } = response
      
      // 保存token
      commit('SET_TOKEN', token)
      
      // 获取用户详细信息
      await dispatch('getUserInfo')
      
      return userInfo
    } catch (error) {
      commit('SET_TOKEN', '')
      throw error
    }
  },
  
  // 获取用户信息
  async getUserInfo({ commit, state }) {
    try {
      const response = await this._vm.$api.user.getInfo()
      commit('SET_USER_INFO', response.userInfo)
      commit('SET_PERMISSIONS', response.permissions)
      commit('SET_DEPARTMENT', response.department)
      return response
    } catch (error) {
      console.error('获取用户信息失败:', error)
      throw error
    }
  },
  
  // 企业微信获取用户信息
  async getWxUserInfo({ commit }, wxCode) {
    try {
      const response = await this._vm.$api.user.getWxUserInfo(wxCode)
      commit('SET_WX_USER_INFO', response)
      return response
    } catch (error) {
      console.error('获取企业微信用户信息失败:', error)
      throw error
    }
  },
  
  // 退出登录
  async logout({ commit }) {
    try {
      // 调用退出接口
      await this._vm.$api.user.logout()
    } catch (error) {
      console.error('退出登录失败:', error)
    } finally {
      // 清除本地数据
      commit('CLEAR_USER')
    }
  },
  
  // 更新用户信息
  async updateUserInfo({ commit }, userInfo) {
    try {
      const response = await this._vm.$api.user.updateInfo(userInfo)
      commit('SET_USER_INFO', response)
      return response
    } catch (error) {
      console.error('更新用户信息失败:', error)
      throw error
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}